"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const WorldMap_vue_1 = __importDefault(require("@/presentation/components/worldmap/WorldMap.vue"));
const vue_1 = require("vue");
const Question_class_1 = __importDefault(require("./Question.class"));
exports.default = (0, vue_1.defineComponent)({
    components: {
        WorldMap: WorldMap_vue_1.default
    },
    setup: () => {
        const component = new Question_class_1.default();
        (0, vue_1.onUpdated)(component.preloadNextQuestionImages.bind(component));
        component.preloadNextQuestionImages();
        return {
            questionNumber: component.questionNumber,
            questionTotal: component.questionTotal,
            question: component.question,
            progress: component.progress,
            questionOptionClass: component.questionOptionClass,
            countrySelected: component.countrySelected.bind(component),
            answerQuestion: component.answerQuestion.bind(component),
        };
    }
});
